module.exports = __webpack_public_path__ + "3ed872dfa8a29c13e05dd0e798d91906.png";